// Usage: import { icons } from 'app/constants/icons';
// E.g  Usage: {icons.MediaSeekBackwardButton.icon}

export const getMediaControlBarIcon = (requestIocn, iconText) => {
  // const iconTitle = iconText || ''
  // const iconStyle = {
  //   fontSize: '1.5rem'
  // }

  // const bigIconStyle = {
  //   fontSize: '3rem'
  // }

  const icons = {
    MediaPlayCenterButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={36}
          height={36}
          viewBox='0 0 24 24'
          fill='#fafafa'
        >
          <title>Play</title>
          <polygon points='6 3 20 12 6 21 6 3' />
        </svg>
      )
    },
    MediaPlayButton: {
      icon: (
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={22}
        //   height={22}
        //   viewBox="0 0 256 256"
        // >
        //   <path d="M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z" />
        // </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          viewBox='0 0 24 24'
          fill='#fafafa'
        >
          <title>Play</title>
          <polygon points='6 3 20 12 6 21 6 3' />
        </svg>
      )
    },
    MediaPauseCenterButton: {
      icon: (
        <svg
          width={32}
          height={32}
          fill='#fafafa'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
        >
          <title>Pause</title>
          <path d='M6 20h4V4H6v16Zm8-16v16h4V4h-4Z' />
        </svg>
      )
    },
    MediaPauseButton: {
      icon: (
        <svg
          width={22}
          height={22}
          fill='#fafafa'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
        >
          <title>Pause</title>
          <path d='M6 20h4V4H6v16Zm8-16v16h4V4h-4Z' />
        </svg>
      )
    },
    MediaSeekBackwardButton: {
      icon: (
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={22}
        //   height={22}
        //   viewBox="0 0 256 256"
        // >
        //   <path d="M232,71.84V184.16a15.92,15.92,0,0,1-24.48,13.34L128,146.86v37.3a15.92,15.92,0,0,1-24.48,13.34L15.33,141.34a15.8,15.8,0,0,1,0-26.68L103.52,58.5A15.91,15.91,0,0,1,128,71.84v37.3L207.52,58.5A15.91,15.91,0,0,1,232,71.84Z" />
        // </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          viewBox='0 0 24 24'
          fill='#fafafa'
        >
          <title>Seek Back</title>
          <polygon points='11 19 2 12 11 5 11 19' />
          <polygon points='22 19 13 12 22 5 22 19' />
        </svg>

      )
    },
    MediaSeekForwardButton: {
      icon: (
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={22}
        //   height={22}
        //   viewBox="0 0 256 256"
        // >
        //   <path d="M256,128a15.76,15.76,0,0,1-7.33,13.34L160.48,197.5A15.91,15.91,0,0,1,136,184.16v-37.3L56.48,197.5A15.91,15.91,0,0,1,32,184.16V71.84A15.91,15.91,0,0,1,56.48,58.5L136,109.14V71.84A15.91,15.91,0,0,1,160.48,58.5l88.19,56.16A15.76,15.76,0,0,1,256,128Z" />
        // </svg>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          viewBox='0 0 24 24'
          fill='#fafafa'
        >
          <title>Seek Forward</title>
          <polygon points='13 19 22 12 13 5 13 19' />
          <polygon points='2 19 11 12 2 5 2 19' />
        </svg>

      )
    },
    MediaSettingsMenuButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
          fill='#fafafa'
          width={24}
          height={24}
        >
          <title>Settings</title>
          <path d='M21,14.73l-.8-.66a2,2,0,0,1-.72-1.64c0-.14,0-.29,0-.43s0-.29,0-.43a2,2,0,0,1,.72-1.64l.8-.66A1,1,0,0,0,21.24,8L20.08,6a1,1,0,0,0-1.21-.43l-1,.36a2,2,0,0,1-1.78-.19,5.48,5.48,0,0,0-.74-.43,2,2,0,0,1-1.06-1.45l-.17-1a1,1,0,0,0-1-.84h-2.3a1,1,0,0,0-1,.84l-.17,1A2,2,0,0,1,8.63,5.31a5.48,5.48,0,0,0-.74.43,2,2,0,0,1-1.78.19l-1-.36A1,1,0,0,0,3.92,6L2.76,8A1,1,0,0,0,3,9.27l.8.66a2,2,0,0,1,.72,1.64c0,.14,0,.29,0,.43s0,.29,0,.43a2,2,0,0,1-.72,1.64l-.8.66A1,1,0,0,0,2.76,16l1.16,2a1,1,0,0,0,1.21.43l1-.36a2,2,0,0,1,1.78.19,5.48,5.48,0,0,0,.74.43,2,2,0,0,1,1.06,1.45l.17,1a1,1,0,0,0,1,.84h2.3a1,1,0,0,0,1-.84l.17-1a2,2,0,0,1,1.06-1.45,5.48,5.48,0,0,0,.74-.43,2,2,0,0,1,1.78-.19l1,.36A1,1,0,0,0,20.08,18l1.16-2A1,1,0,0,0,21,14.73ZM12,15a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z' />
        </svg>
      )
    },
    MediaVolumeButtonMute: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          fill='#fafafa'
          viewBox='0 0 256 256'
        >
          <title>Volume Mute</title>
          <path d='M213.92,210.62a8,8,0,1,1-11.84,10.76L160,175.09v48.6a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.55-51A4,4,0,0,1,80,176.18V87.09L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-27.21-55.46a8,8,0,0,0,11.29-.7,40,40,0,0,0,0-52.88,8,8,0,1,0-12,10.57,24,24,0,0,1,0,31.72A8,8,0,0,0,186.71,155.16Zm40.92-80.49a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66ZM153,119.87a4,4,0,0,0,7-2.7V32.25a8.27,8.27,0,0,0-2.88-6.4,8,8,0,0,0-10-.16L103.83,59.33a4,4,0,0,0-.5,5.85ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Z' />
        </svg>
      )
    },
    MediaVolumeButtonLow: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          fill='#fafafa'
          viewBox='0 0 256 256'
        >
          <title>Volume Low</title>
          <path d='M160,32.25V223.69a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.57-51A4,4,0,0,1,80,176.16V79.84a4,4,0,0,1,1.55-3.15l65.57-51a8,8,0,0,1,10,.16A8.27,8.27,0,0,1,160,32.25ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80ZM198,101.56a8,8,0,1,0-12,10.58,24,24,0,0,1,0,31.72,8,8,0,1,0,12,10.58,40,40,0,0,0,0-52.88Z' />
        </svg>
      )
    },
    MediaVolumeButtonHigh: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          fill='#fafafa'
          viewBox='0 0 256 256'
        >
          <title>Volume High</title>
          <path d='M160,32.25V223.69a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.57-51A4,4,0,0,1,80,176.16V79.84a4,4,0,0,1,1.55-3.15l65.57-51a8,8,0,0,1,10,.16A8.27,8.27,0,0,1,160,32.25ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Zm126.77,20.84a8,8,0,0,0-.72,11.3,24,24,0,0,1,0,31.72,8,8,0,1,0,12,10.58,40,40,0,0,0,0-52.88A8,8,0,0,0,186.74,100.84Zm40.89-26.17a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66Z' />
        </svg>
      )
    },
    MediaPipButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={24}
          height={24}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth={1.8}
          strokeLinecap='round'
          strokeLinejoin='round'
          className='lucide lucide-picture-in-picture-2'
        >
          <title>Picture-in-picture</title>
          <path d='M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4' />
          <rect width={10} height={7} x={12} y={13} rx={2} />
        </svg>
      )
    },
    MediaFullscreenButton: {
      icon: (
        <svg
          width={24}
          height={24}
          fill='#fafafa'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
        >
          <title>Fullscreen</title>
          <path d='M19,3H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19V8.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5V5A2,2,0,0,0,19,3ZM3,5V8.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,5,8.5V5H8.5A.5.5,0,0,0,9,4.5v-1A.5.5,0,0,0,8.5,3H5A2,2,0,0,0,3,5ZM19,15.5V19H15.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H19a2,2,0,0,0,2-2V15.5a.5.5,0,0,0-.5-.5h-1A.5.5,0,0,0,19,15.5ZM4.5,15h-1a.5.5,0,0,0-.5.5V19a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H5V15.5A.5.5,0,0,0,4.5,15Z' />
        </svg>
      )
    },
    MediaExitFullscreenButton: {
      icon: (
        <svg
          width={24}
          height={24}
          fill='#fafafa'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
        >
          <title>Exit Fullscreen</title>
          <path d='M16,9h4.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H17V3.5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5V8A1,1,0,0,0,16,9ZM9,8V3.5A.5.5,0,0,0,8.5,3h-1a.5.5,0,0,0-.5.5V7H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H8A1,1,0,0,0,9,8Zm8,12.5V17h3.5a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5H16a1,1,0,0,0-1,1v4.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,17,20.5ZM7.5,21h1a.5.5,0,0,0,.5-.5V16a1,1,0,0,0-1-1H3.5a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H7v3.5A.5.5,0,0,0,7.5,21Z' />
        </svg>

      )
    },
    MediaDownloadButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={24}
          height={24}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth={1.8}
          strokeLinecap='round'
          strokeLinejoin='round'
          className='lucide lucide-download'
        >
          <title>Download</title>
          <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
          <polyline points='7 10 12 15 17 10' />
          <line x1={12} x2={12} y1={15} y2={3} />
        </svg>

      )
    },
    MediaEnableCaptionsButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={24}
          height={24}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth={1.8}
          strokeLinecap='round'
          strokeLinejoin='round'
          className='lucide lucide-captions'
        >
          <title>Enable Caption</title>
          <rect width={18} height={14} x={3} y={5} rx={2} ry={2} />
          <path d='M7 15h4M15 15h2M7 11h2M13 11h4' />
        </svg>
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={28}
        //   height={28}
        //   fill="#fafafa"
        //   viewBox="0 0 256 256"
        // >
        //   <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM116,162.64a40,40,0,1,1,0-69.28,8,8,0,1,1-8,13.85,24,24,0,1,0,0,41.58,8,8,0,0,1,8,13.85Zm80,0a40,40,0,1,1,0-69.28,8,8,0,1,1-8,13.85,24,24,0,1,0,0,41.58,8,8,0,0,1,8,13.85Z" />
        // </svg>
      )
    },
    MediaDisableCaptionsButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={24}
          height={24}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth={1.8}
          strokeLinecap='round'
          strokeLinejoin='round'
          className='lucide lucide-captions-off'
        >
          <title>Disable Caption</title>
          <path d='M10.5 5H19a2 2 0 0 1 2 2v8.5' />
          <path d='M17 11h-.5' />
          <path d='M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2' />
          <path d='m2 2 20 20' />
          <path d='M7 11h4' />
          <path d='M7 15h2.5' />
        </svg>
        // <svg
        //   xmlns="http://www.w3.org/2000/svg"
        //   width={28}
        //   height={28}
        //   fill="#fafafa"
        //   viewBox="0 0 256 256"
        // >
        //   <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192ZM118.92,151.71A8,8,0,0,1,116,162.64a40,40,0,1,1,0-69.28,8,8,0,1,1-8,13.85,24,24,0,1,0,0,41.58A8,8,0,0,1,118.92,151.71Zm80,0A8,8,0,0,1,196,162.64a40,40,0,1,1,0-69.28,8,8,0,1,1-8,13.85,24,24,0,1,0,0,41.58A8,8,0,0,1,198.92,151.71Z" />
        // </svg>

      )
    },
    MediaChaptersButton: {
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={22}
          height={22}
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth={1.8}
          strokeLinecap='round'
          strokeLinejoin='round'
          className='lucide lucide-layout-list-icon lucide-layout-list'
        >
          <title>Chapters</title>
          <rect width='7' height='7' x='3' y='3' rx='1' />
          <rect width='7' height='7' x='3' y='14' rx='1' />
          <path d='M14 4h7' />
          <path d='M14 9h7' />
          <path d='M14 15h7' />
          <path d='M14 20h7' />
        </svg>
      )
    }
  }
  const renderIcon = icons[requestIocn].icon

  return renderIcon
}
